import { useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft, ScanBarcode } from "lucide-react";
import { Button } from "@/components/ui/button";

interface AccessDeniedProps {
    title?: string;
    message?: string;
}

export default function AccessDenied({
    title = "Acceso Denegado",
    message = "No tienes permisos para acceder a esta sección. Contacta al administrador si crees que es un error.",
}: AccessDeniedProps) {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10 mb-6">
                <ShieldAlert className="w-8 h-8 text-destructive" />
            </div>
            <h1 className="text-2xl font-bold mb-2">{title}</h1>
            <p className="text-muted-foreground max-w-md mb-8">{message}</p>
            <div className="flex gap-3">
                <Button variant="outline" onClick={() => navigate(-1)}>
                    <ArrowLeft className="w-4 h-4 mr-2" />
                    Volver
                </Button>
                <Button onClick={() => navigate("/pos")}>
                    <ScanBarcode className="w-4 h-4 mr-2" />
                    Ir al POS
                </Button>
            </div>
        </div>
    );
}
